// Runtime configuration, fetched from `config.json` at the site root before
// the app first renders (see main.tsx). `deploy.yml` writes it from
// `terraform output` after apply (ADR 0024), so one build serves any
// environment.
//
// Since #248 the app is same-origin behind the BFF — no `apiBase` any more,
// every call is a relative `/api/*` / `/auth/*`. The only thing left here is
// the OTel namespace.

export interface RuntimeConfig {
  // Shared OTel resource namespace (ADR 0015), written at deploy from the
  // `otel_namespace` Terraform output, so a browser span carries the same
  // `service.namespace` as every backend service. Absent in local dev — the
  // tracer omits the attribute.
  otelNamespace?: string;
}

let loaded: RuntimeConfig = {};

export function setRuntimeConfig(cfg: unknown): void {
  loaded = cfg && typeof cfg === "object" ? (cfg as RuntimeConfig) : {};
}

/** Best-effort fetch of `${BASE_URL}config.json`. Never throws. */
export async function fetchRuntimeConfig(): Promise<void> {
  try {
    const res = await fetch(`${import.meta.env.BASE_URL}config.json`, { cache: "no-store" });
    if (res.ok) setRuntimeConfig(await res.json());
  } catch {
    // no config.json (local dev, or not written yet) — fall through
  }
}

/** Shared OTel resource namespace (ADR 0015), or "" when not configured. */
export function otelNamespace(): string {
  return (loaded.otelNamespace ?? "").trim();
}
